export interface DashboardItem {
  id: string
  tail: string
  type: string
  location: string
  time: string
  status: 'critical' | 'warning' | 'info' | 'success' | 'neutral'
  actionLabel?: string
  description?: string
  origin?: string
  destination?: string
  isArrival?: boolean
  isDeparture?: boolean
  warnings?: {
    id: string
    level: 'critical' | 'warning'
    message: string
    action?: string
  }[]
  services?: {
    id: string
    name: string
    time?: string
    status: 'pending' | 'in-progress' | 'completed' | 'requested'
  }[]
}

export const needsAttention: DashboardItem[] = [
  {
    id: 'na-1',
    tail: 'N567JK',
    type: 'G650',
    location: 'Hangar A',
    time: 'Now',
    status: 'critical',
    warnings: [
      { id: 'w-1', level: 'critical', message: 'Lease expired', action: 'Renew' },
      { id: 'w-2', level: 'warning', message: 'Insurance expiring (5d)', action: 'View' },
    ],
  },
  {
    id: 'na-2',
    tail: 'N890LM',
    type: 'PC12',
    location: 'TD-12',
    time: 'Now',
    status: 'warning',
    warnings: [
        { id: 'w-3', level: 'warning', message: 'Overstaying +2d', action: 'Check Out' }
    ]
  },
  {
    id: 'na-3',
    tail: 'N999XX', // Changed tail to distinguish from first one
    type: 'G550',
    location: 'Ramp 2',
    time: 'Now',
    status: 'critical',
    warnings: [
        { id: 'w-4', level: 'critical', message: 'Fuel Release Missing', action: 'Upload' },
        { id: 'w-5', level: 'warning', message: 'Crew car request unfulfilled', action: 'Assign' }
    ]
  },
]

export const arrivals: DashboardItem[] = [
  {
    id: 'arr-1',
    tail: 'N123AB',
    type: 'G650',
    location: 'Hangar B',
    time: '08:30',
    origin: 'KASE',
    status: 'info',
    actionLabel: 'Check In',
    isArrival: true,
    services: [
        { id: 's-1', name: 'Fuel', status: 'requested', time: 'On arrival' },
        { id: 's-2', name: 'Lav', status: 'requested' }
    ]
  },
  {
    id: 'arr-2',
    tail: 'N789XY',
    type: 'CL350',
    location: 'TD-05',
    time: '10:15',
    origin: 'KTEB',
    status: 'info',
    actionLabel: 'Check In',
    isArrival: true,
    services: []
  },
  {
    id: 'arr-3',
    tail: 'N345PQ',
    type: 'PC12',
    location: 'Unassigned',
    time: '14:00',
    origin: 'KLAS',
    status: 'warning',
    actionLabel: 'Assign + Check In',
    isArrival: true,
    description: 'Pax: 4',
    services: [
        { id: 's-3', name: 'Catering', status: 'pending', time: '13:45' }
    ]
  },
  {
    id: 'arr-4',
    tail: 'N999ZZ',
    type: 'C172',
    location: 'Ramp 1',
    time: '15:30',
    origin: 'KAPA',
    status: 'info',
    actionLabel: 'Check In',
    isArrival: true,
  },
   {
    id: 'arr-5',
    tail: 'N888YY',
    type: 'BE35',
    location: 'Tie-down',
    time: '16:15',
    origin: 'KBJC',
    status: 'info',
    actionLabel: 'Check In',
    isArrival: true,
  },
    {
    id: 'arr-6',
    tail: 'N777XX',
    type: 'PA28',
    location: 'Hangar C',
    time: '17:00',
    origin: 'KCOS',
    status: 'info',
    actionLabel: 'Check In',
    isArrival: true,
  },
]

export const departures: DashboardItem[] = [
  {
    id: 'dep-1',
    tail: 'N456CD',
    type: 'G550',
    location: 'Ramp 2',
    time: '09:00',
    destination: 'KJFK',
    status: 'neutral',
    description: 'Pull-up: 08:30',
    actionLabel: 'Mark Departed',
    isDeparture: true,
    services: [
        { id: 's-4', name: 'GPU', status: 'in-progress', time: '08:15' },
        { id: 's-5', name: 'Ice', status: 'completed' }
    ]
  },
  {
    id: 'dep-2',
    tail: 'N012LM',
    type: 'CJ4',
    location: 'Hangar C',
    time: '11:30',
    destination: 'KORD',
    status: 'neutral',
    actionLabel: 'Mark Departed',
    isDeparture: true,
     services: [
        { id: 's-6', name: 'Fuel', status: 'completed', time: 'Yesterday' }
    ]
  },
  {
    id: 'dep-3',
    tail: 'N678RS',
    type: 'PC24',
    location: 'TD-01',
    time: '14:45',
    destination: 'KDEN',
    status: 'neutral',
    actionLabel: 'Mark Departed',
    isDeparture: true,
  },
  {
    id: 'dep-4',
    tail: 'N901TU',
    type: 'G280',
    location: 'Ramp 3',
    time: '16:00',
    destination: 'KMIA',
    status: 'neutral',
    actionLabel: 'Mark Departed',
    isDeparture: true,
  },
]

export const stats = {
  needsAttention: 5,
  arrivals: 6,
  onGround: 28,
  departures: 4,
}
